import {useEffect, useMemo, useState} from 'react'
import {KTIcon, stringifyRequestQuery} from '../../../../../../_metronic/helpers'
import {useListView} from '../../core/ListViewProvider'
import {useQueryRequest} from '../../core/QueryRequestProvider'
import {useLocation} from 'react-router-dom'
import {useAuth, MenuModel, getMenuAccess} from '../../../../auth'
import LoadingButtonWrapper from '../../../../../components/LoadingButtonWrapper'
import {downloadFile} from '../../../../../utils/file'
import {showError} from '../../../../../utils/toast'

const JudiListToolbar = () => {
  const {setItemIdForUpdate} = useListView()
  const openAddUserModal = () => {
    setItemIdForUpdate(null)
  }
  const {state} = useQueryRequest()
  const [query, setQuery] = useState<string>(stringifyRequestQuery(state))
  const updatedQuery = useMemo(() => stringifyRequestQuery(state), [state])
  const {pathname} = useLocation()
  const {currentMenu} = useAuth()
  const [menuAccess, setMenuAccess] = useState<MenuModel | undefined>(undefined)
  const [loadingExcel, setLoadingExcel] = useState(false)
  const exportUrl = 'report/judi/excel'

  useEffect(() => {
    setMenuAccess(getMenuAccess(currentMenu ?? [], pathname))
  }, [currentMenu])

  useEffect(() => {
    if (query !== updatedQuery) {
      setQuery(updatedQuery)
    }
  }, [updatedQuery])

  useEffect(() => {
    if (query !== updatedQuery) {
      setQuery(updatedQuery)
    }
  }, [updatedQuery])

  const excel = async () => {
    try {
      setLoadingExcel(true)
      await downloadFile(`${exportUrl}?${query}`, `JudiKonvensional.xlsx`)
    } catch (err: any) {
      showError(err.message)
    } finally {
      setLoadingExcel(false)
    }
  }

  return (
    <div
      className='d-flex justify-content-md-end flex-md-row flex-column w-100 w-md-auto'
      data-kt-student-table-toolbar='base'
    >
      {/*<UserListFilter />*/}

      {/* begin::Add student */}
      {menuAccess?.canCreate && (
        <button type='button' className='btn btn-warning mt-5 mt-md-0 me-3' onClick={openAddUserModal}>
          <KTIcon iconName='plus' className='fs-2' />
          Add
        </button>
      )}

      <LoadingButtonWrapper isLoading={loadingExcel}>
        <button type='button' className='btn btn-light-success mt-5 mt-md-0' onClick={excel}>
          <KTIcon iconName='exit-up' className='fs-2' />
          Export
        </button>
      </LoadingButtonWrapper>
      {/* end::Add student */}
    </div>
  )
}

export {JudiListToolbar}
